import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-inline-notification',
  templateUrl: './inline-notification.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: [':host { display: block }'],
})
export class InlineNotificationComponent {
  @Input() type: 'error' | 'info' | 'success' | 'warning';
  @Input() isDismissible = false;
  @Output() readonly dismiss = new EventEmitter<void>();
}
